/**
 * BackgroundCheck Service
 * Register Angular Services for all things BackgroundCheck
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('BackgroundCheck', ['$resource', function($resource){
    return $resource('/api/v2/backgroundCheck/:id', null, {
        'update': { method:'PUT' }
    });
}]);
